export default {
  banner: {
    title: "Cloud Native",
    subtitle:
      "“Cloud native is the implementation of Authing's computing philosophy. Adopting this architecture will continue to change the productivity of the software industry.”",
    character: "—— Yang Xie · Authing CEO",
    img: "//files.authing.co/authing-website/cloud-native-banner-img-en.png",
  },
  "side-content": {
    item1: "Cloud Native Introduction",
    item2: "Impact & History",
    item3: "Authing Identity Cloud",
    item4: "Cloud Infrastructure",
    item5: "Kubernetes",
    item6: "Cloud Neutral",
  },
  item1: {
    title: "Cloud Native Introduction",
    content1:
      "Cloud native is a way to build and run applications using the advantages of the cloud computing interaction model to help companies deliver business software quickly, continuously, reliably, and on a large scale.",
    content2:
      "One sentence explanation: Cloud native applications are applications developed to run on the cloud.",
    cardData: {
      0: {
        title: "Container",
        content:
          "Container is a kind of computing unit. As the packaging form of application, it gives the application the ability of independence and portability.",
      },
      1: {
        title: "Continuous delivery",
        content:
          "The pipeline of continuous integration and continuous release is constructed by using the light characteristic of container.",
      },
      2: {
        title: "DevOps",
        content:
          "Devops refers to the pipelining of the development, testing and production process, so as to reduce the accidents caused by the wrong configuration of the application dependency.",
      },
      3: {
        title: "Microservice",
        content:
          "Microservices refer to different containers run by different units or features of the system. The number of containers for each service can be adjusted according to its own load.",
      },
    },
  },
  item2: {
    title: "Impact & History",
    content:
      "In order to solve the problems of traditional applications: slow upgrades, bloated architecture, faults that cannot be quickly located, and problems that cannot be quickly resolved, cloud native is an inevitable orientation of cloud computing, and its significance is to make the cloud the cornerstone of the success of the cloud strategy, not a hindrance . Cloud native can:",
    liData: {
      0: "Improve the efficiency of application development",
      1: "Change the organizational structure of enterprises",
      2: "Influence a company's decision",
    },
    img: "//files.authing.co/authing-website/cloud-native-timeline-en.png",
  },
  item3: {
    title: "Authing Identity Cloud",
    subTitle1: "Cloud Infrastructure",
    subContent1:
      "Authing's infrastructure is all on the cloud, and currently, our core business architecture is on AWS, whose components provide us with an efficient and stable infrastructure platform.",
    subContent11:
      "As a leading global cloud service platform, Amazon Web Services offers a wide range of computing, storage, and security services that can meet the needs of different types of workflows, and its worldwide services can meet the needs of many large multinational corporations' global business operations. This provides powerful computing support and data security for Authing's current business operations, as well as laying the foundation for future development.",
    subContent111:
      "At the same time, Authing has received comprehensive support from Amazon Web Services in terms of business support and marketing. Through deep cooperation, Authing provides technology and services to Amazon Web Services customers in industries such as automotive, internet, gaming, and cross-border business, achieving excellent results that satisfy customers.",
    subTitle2: "Kubernetes",
    subContent2:
      "Authing adopts kubernetes containerization technology, supports public cloud, hybrid cloud and private cloud deployment, supports minute level elastic expansion, and supports 100 million level user authentication access scenarios.",
    subContentImg2:
      "//files.authing.co/authing-website/cloud-native-kubernetes-en.jpg",
    subTitle3: "Cloud Neutral",
    subContent3: `We can not change the existing cloud infrastructure of users, we can only maximize the compatibility with the cloud environment of users. Therefore, we propose the concepts of "cloud neutrality" and "Authing inside". In the multi cloud environment, Authing should maintain its neutral characteristics. In the mixed cloud or private cloud environment, Authing is integrated into the customer's IT system like Intel.`,
    subContentImg3:
      "//files.authing.co/authing-website/cloud-native-cloud-center-en.jpg",
    subContent4:
      "Authing has accumulated a lot of experience in cloud native, at the same time, it also attaches great importance to and is willing to help customer enterprises apply cloud computing technology, and help customers build enterprise cloud native platform. There is unlimited potential in the cloud technology revolution. Authing will always cultivate the identity infrastructure, provide perfect and secure user authentication and access management services for enterprises and developers, and provide single sign on SSO, cloud native identity platform, cloud native identity management and unified identity authentication platform.",
  },
};
